import { render } from "./TudouActivty.vue?vue&type=template&id=68b3994a&scoped=true"
import script from "./TudouActivty.vue?vue&type=script&lang=js"
export * from "./TudouActivty.vue?vue&type=script&lang=js"

import "./TudouActivty.vue?vue&type=style&index=0&id=68b3994a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68b3994a"]])

export default __exports__